// const BaseUrl = `https://www.yuanshouhr.com`
const BaseUrl = `http://39.107.92.53:4747`
// const BaseUrl = `http://192.168.10.81:3000`
export { BaseUrl }
